exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2F_0ZumEjnjjxjDjt7rpD_ .ms-Dialog-subText{font-size:14px;font-weight:400}", ""]);

// exports
exports.locals = {
	"dialogContainer": "_2F_0ZumEjnjjxjDjt7rpD_"
};